// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.info_5a51ff65 {
  display: block;
  line-height: 1;
}
.info_pointer_5a51ff65 {
  cursor: pointer;
}
.info__icon_5a51ff65 {
  color: #657682;
}
.info__icon_5a51ff65:hover {
  color: #26649e;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"info": `info_5a51ff65`,
	"info_pointer": `info_pointer_5a51ff65`,
	"info__icon": `info__icon_5a51ff65`
};
export default ___CSS_LOADER_EXPORT___;
